<template>
  <div class="sidebar">
    <div class="logo">
      <img src="../assets/hermes_svg.svg" alt="" height="65px">
    </div>

    
    <el-row class="tac">
      <el-col>
        
        <el-menu :default-active="defaultIndex" class="el-menu-vertical-demo el-menu--dark" :router="true">
          <el-menu-item v-if="getWritePrivilege==1" index="dashboard" :route="{name: 'dashboard'}">
            {{ $t('sideBar.dashboard') }}
          </el-menu-item>
          <el-menu-item v-if="getReadPrivilege==1" index="product" :route="{name: 'product', query: {page: 1}}">
            {{ $t('sideBar.product') }}
          </el-menu-item>
          <el-menu-item v-if="getOrderPrivilege==1" index="order" :route="{name: 'order', query: {page: 1}}">
            {{ $t('sideBar.order') }}
          </el-menu-item>
          <el-menu-item v-if="getWritePrivilege==1"  index="user" :route="{name: 'user', query: {page: 1}}">
            {{ $t('sideBar.user') }}
          </el-menu-item>
          <el-menu-item v-if="getWritePrivilege==1"  index="store" :route="{name: 'store', query: {page: 1}}">
            {{ $t('sideBar.store') }}
          </el-menu-item>
          <el-menu-item v-if="getWritePrivilege==1"  index="subsidiary" :route="{name: 'subsidiary', query: {page: 1}}">
            {{ $t('sideBar.subsidiary') }}
          </el-menu-item>
          <el-menu-item v-if="getWritePrivilege==1"  index="channel" :route="{name: 'channel', query: {page: 1}}">
            {{ $t('sideBar.channel') }}
          </el-menu-item>
          <!-- <el-menu-item v-if="getWritePrivilege==1"  index="tag" :route="{name: 'tag', query: {page: 1}}">
            {{ $t('sideBar.tag') }}
          </el-menu-item> -->
          <el-menu-item v-if="getReadTagOrderPrivilege==1"  index="vechainorder" :route="{name: 'vechainorder', query: {page: 1}}">
            {{ $t('sideBar.vechainorder') }}
          </el-menu-item>
          <el-menu-item v-if="getWritePrivilege==1"  index="admin" :route="{name: 'admin', query: {page: 1}}">
            {{ $t('sideBar.admin') }}
          </el-menu-item>
           <el-menu-item v-if="getAdminPrivilege"  index="logs" :route="{name: 'logs', query: {page: 1}}">
            {{ $t('sideBar.logs') }}
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
  import './sideBar.css'
  export default {
    props: {
      defaultIndex: String
    },
    computed: {
    ...mapGetters(['getWritePrivilege','getAdminPrivilege', 'getReadPrivilege', 'getReadTagOrderPrivilege', 'getOrderPrivilege'])
    },
    name: 'sidebar',
    methods: {}
  }

</script>



// WEBPACK FOOTER //
// sideBar.vue?78337389